export default __webpack_public_path__ + "static/media/user.13df436f.svg";